import PrivacyPolicy from "./PrivacyPolicy";


export default {
    name     : 'dialog_privacy_policy',
    component: PrivacyPolicy,
    dialog   : {
        'max-width': "500px"
    }
}
